var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSapStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5V0L24 24L0 32.5H32.5Z",
    fill: "url(#paint0_linear_1298_5139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5L65 32.5L41 24L32.5 -1.42062e-06L32.5 32.5Z",
    fill: "url(#paint1_linear_1298_5139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5L3.87559e-07 32.5L24 41L32.5 65L32.5 32.5Z",
    fill: "url(#paint2_linear_1298_5139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5L32.5 65L41 41L65 32.5L32.5 32.5Z",
    fill: "url(#paint3_linear_1298_5139)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1298_5139",
    x1: 2.06264,
    y1: 0.00000636521,
    x2: 37.4313,
    y2: 5.39018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#D21D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#E24231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1298_5139",
    x1: 65,
    y1: 2.06264,
    x2: 59.6098,
    y2: 37.4313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#D21D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#E24231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1298_5139",
    x1: 12,
    y1: 55,
    x2: 50.2061,
    y2: -16.0694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#D21D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#E24231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1298_5139",
    x1: 61,
    y1: 67.5,
    x2: 6.23286,
    y2: 45.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#D21D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#E24231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapStar);
export default __webpack_public_path__ + "static/media/SapStar.05055a4b3b01ccf7f7d2eb4ee704c68b.svg";
export { ForwardRef as ReactComponent };